import { Link } from "react-router-dom";

const points = [
  {
    icon: "ri-flashlight-line",
    title: "每日更新",
    desc: "每天同步当日及近期重点赛事，覆盖赛程预告与结果速递。",
  },
  {
    icon: "ri-file-list-3-line",
    title: "深度详情",
    desc: "从赛事背景、参赛阵容到赛程安排，提供结构化的详细信息。",
  },
  {
    icon: "ri-filter-3-line",
    title: "多维筛选",
    desc: "按类型、地区、时间与热门标签快速筛选，精准定位感兴趣的内容。",
  },
  {
    icon: "ri-shield-star-line",
    title: "权威梳理",
    desc: "对赛事信息进行统一整理与交叉核对，帮助读者高效理解赛况。",
  },
];

export default function PlatformIntro() {
  return (
    <section className="mx-auto mt-20 max-w-[1280px] px-4 md:px-6">
      <div className="grid grid-cols-1 gap-10 rounded-lg border border-background-200 bg-background-100 p-6 md:p-10 lg:grid-cols-2 lg:items-center">
        <div>
          <span className="inline-flex items-center gap-1 text-xs font-semibold uppercase tracking-widest text-accent-600">
            <span className="h-1 w-1 rounded-full bg-accent-500"></span>
            关于平台
          </span>
          <h2 className="mt-3 font-heading text-2xl font-extrabold text-foreground-950 md:text-3xl">
            51每日大赛今日黑聚集地详情
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-700 md:text-base">
            我们是一站式的赛事资讯平台，专注为电竞与体育赛事爱好者提供最新每日大赛信息。通过清晰的分类体系、详尽的赛事详情与实时更新的动态内容，帮助用户在海量赛事中快速获取权威资讯，深入理解每一场比赛的看点与走向。
          </p>
          <div className="mt-6 flex flex-wrap gap-3">
            <Link
              to="/about"
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
            >
              了解更多
              <i className="ri-arrow-right-line"></i>
            </Link>
            <Link
              to="/special"
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-5 py-2.5 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-600"
            >
              浏览专题
            </Link>
          </div>
        </div>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
          {points.map((point) => (
            <div
              key={point.title}
              className="rounded-lg border border-background-200 bg-background-50 p-5"
            >
              <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-accent-100 text-accent-700">
                <i className={`${point.icon} text-xl`}></i>
              </span>
              <h3 className="mt-4 font-heading text-base font-bold text-foreground-950">
                {point.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{point.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}